import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import {routes} from './routes'
import store from './store'
import Vuex from 'vuex'
import Google from "vue-loading-spinner/src/components/Google.vue";
import VueNativeNotification from 'vue-native-notification'
import VueYouTubeEmbed from 'vue-youtube-embed'


Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})

Vue.use(VueYouTubeEmbed)

Vue.component("mushonga", Google)
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.config.productionTip = false

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  let auth = ["Home", "Chat", "Profile", "Round", "Stand", "SingleRound"];

  // if(to.path.substr(0,6) === "/admin"){
  //   console.log("Unauthorised", store.getters.user)
  // }

  if (auth.includes(to.name) && !localStorage.getItem("token")){
    next({ name: 'Login' })
  }
  else next()
})


new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
